/**
 * RECENTLY VIEWED — ÔNNE
 *
 * Mantiene un historial de PDPs visitadas en localStorage (clave PROPIA,
 * aislada de `viewedProducts` que usa el predictive-search, para no romperlo)
 * y renderiza las cards vía Section Rendering API reusando product-card-onne.
 *
 * Flujo en cada PDP:
 *   1. Lee el historial (lista de handles, más reciente primero).
 *   2. Calcula qué mostrar = historial menos el producto actual, hasta `limit`.
 *   3. Inserta el producto actual al frente del historial (para las próximas PDPs).
 *   4. Si hay algo que mostrar, fetchea cada card y desoculta la sección.
 */
class RecentlyViewedOnne extends HTMLElement {
  static #KEY = 'onne:recently-viewed';
  static #MAX = 12;
  static #CARD_SECTION = 'recently-viewed-card-onne';

  connectedCallback() {
    const current = this.dataset.currentHandle;
    const limit = parseInt(this.dataset.limit || '10', 10);
    const prefix = this.dataset.rootUrl || '/';

    let history = [];
    try {
      history = JSON.parse(localStorage.getItem(RecentlyViewedOnne.#KEY) || '[]');
    } catch (e) {
      history = [];
    }

    // Qué mostrar: historial sin el actual, hasta `limit`.
    const toShow = history.filter((h) => h && h !== current).slice(0, limit);

    // Guardar historial actualizado: actual al frente, dedup, cap.
    if (current) {
      const next = [current, ...history.filter((h) => h && h !== current)].slice(
        0,
        RecentlyViewedOnne.#MAX
      );
      try {
        localStorage.setItem(RecentlyViewedOnne.#KEY, JSON.stringify(next));
      } catch (e) {
        /* localStorage lleno o bloqueado: ignorar */
      }
    }

    if (toShow.length === 0) return; // sin historial → la sección queda hidden

    this.#render(toShow, prefix);
  }

  /**
   * Fetchea cada card vía Section Rendering API y las inserta en orden.
   * @param {string[]} handles
   * @param {string} prefix - routes.root_url (locale-aware)
   */
  async #render(handles, prefix) {
    const listEl = this.querySelector('[data-rv-list]');
    if (!listEl) return;

    const base = prefix.endsWith('/') ? prefix : prefix + '/';
    const htmls = await Promise.all(
      handles.map(async (handle) => {
        try {
          const res = await fetch(
            `${base}products/${handle}?section_id=${RecentlyViewedOnne.#CARD_SECTION}`
          );
          if (!res.ok) return null;
          return await res.text();
        } catch (e) {
          return null;
        }
      })
    );

    let any = false;
    for (const html of htmls) {
      if (!html) continue;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const card = tmp.querySelector('.recently-viewed-onne__item') || tmp.firstElementChild;
      if (card) {
        listEl.appendChild(card);
        any = true;
      }
    }

    if (any) this.hidden = false;
  }
}

if (!customElements.get('recently-viewed-onne')) {
  customElements.define('recently-viewed-onne', RecentlyViewedOnne);
}
